import React from "react";
import PropTypes from "prop-types";

const Header = ({ children, title }) => {
    return (
        <header className="header">
            <div className="header__container">
                <div className="header__item">
                    <h1>{title}</h1>
                </div>
                {children && (
                    <div className="header__item">
                        {children}
                    </div>
                )}
            </div>
        </header>
    );
};

Header.propTypes = {
    children: PropTypes.node,
    title: PropTypes.string,
};

Header.defaultProps = {
    children: "",
    title: "",
};

export default Header;
